import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, DoCheck, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { isUndefined, isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { ControlContainer, NgForm } from '@angular/forms';
import { confirmRemoveFromList } from '../../../_infrastructure/TableEdit/TableEditBase';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { WorkflowComponent } from '../../workflow.component';
import DateHelpers from '../../../_infrastructure/DateHelpers';
import { SubscriberInformationService } from '../../../_infrastructure/SubscriberInfo/SubscriberInformationService';

@Component({
    selector: 'external-pension-status',
    templateUrl: './external-pension-status.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class ExternalPensionStatusComponent  implements OnInit, OnDestroy, ICardComponent, DoCheck {
  public cardData: models.ExternalPensionStatusVM = {} as models.ExternalPensionStatusVM;
  public cardConfiguration: models.CardVM;
  public subscriber: models.SubscriberInformationVM;
  public isWorkflowOnSubscriber: boolean = false;

  public expandedRowIndex: number = null;
  public expandNewWorkAbroad: boolean = false;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];
  @CommonData(DomainCodes.country)
  public countries: models.DimensionVM[];

  public parentWorkflow: WorkflowComponent;
  public certifiedData;
  public subscriberBirthDate = {};
  public currentDate = new Date();
 
  constructor(private modalService: ModalService, private subscriberInfoService: SubscriberInformationService, private readonly changeDetectorRef: ChangeDetectorRef ) {
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    //TEMP to prevent undefined errors if no stepdata is found
    if (this.isVersion2()) {
      this.subscriberInfoService.getCurrentSubscriber().subscribe((subscriber) => this.subscriber = subscriber);
      this.currentDate = new Date(this.currentDate.setDate(this.currentDate.getDate() - 1));
    }
    if (isNullOrUndefined(this.cardData.workAbroadList))
      this.cardData.workAbroadList = [];
    if (this.isVersion2()) {
      if (this.parentWorkflow.workflowInstance.formData.StepCertification !== undefined) {
      this.certifiedData = this.parentWorkflow.workflowInstance.formData.StepCertification;
      }
    }

  }

  ngDoCheck(): void {
    //Needs to be done in DoCheck because of step data being received asyncrously
    if (isNullOrUndefined(this.cardData.workAbroadList))
      this.cardData.workAbroadList = [];
    if (this.isVersion2()) {
      if (this.parentWorkflow.workflowInstance.formData.StepCertification !== undefined) {
        this.certifiedData = this.parentWorkflow.workflowInstance.formData.StepCertification;
        }
    }
  }

  ngOnDestroy(): void {
  }

  isVersion2() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  checkSteps() {
    let result = false;
    for (let i = 0; i < this.parentWorkflow.steps.length; i++) {
      if (this.parentWorkflow.steps[i].stepCode === "StepSubscriberCGA") {
        result = true;
        break;
      }
    }
    return result;
  }

  ssdiscountOnChange() {
    //if (this.cardData.hasSSDiscount?.toString() !== 'true' && this.certifiedData['identificationData']?.idenCertification !== 'S') {
    if (this.cardData.hasSSDiscount?.toString() !== 'true' && this.certifiedData['socialSecurityData']?.socialCertification !== 'S') {
      this.cardData.beneficiaryNumber = undefined;
    }

    if (this.cardData.hasSSDiscount?.toString() !== 'true') {
      this.cardData.ssRegisterDate = undefined;
    }
  }

  onWorkAbroadChanged(newWorkAbroadList: models.WorkAbroadVM[]) {
    this.cardData.workAbroadList = newWorkAbroadList;
    this.expandedRowIndex = null;
    this.expandNewWorkAbroad = false;
  }
  removeFromList(currentList: any[], indexToRemove: number, event: MouseEvent) {
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      confirmRemoveFromList(currentList, indexToRemove, this.modalService).subscribe(result => {
        if (result)
          this.expandedRowIndex = null;
      });
    }
    event.stopPropagation();
  }
  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }

  dateOfBirthPlus12() {
    var result: Date = new Date(this.subscriber.dateOfBirth);
    result.setFullYear(result.getFullYear() + 12);
    result.setDate(result.getDate() + 1);
    return result;
  }

  isPEDI001DFundament(): boolean {
    let result = false;
    return this.parentWorkflow['workflowInstance']['workflowCode'] === 'PEDI001D';
  }

  formatDate(event: any) {
    DateHelpers.formatDateGeneral(event);
  }

  onlyNumbers(event: any) {
    DateHelpers.onlyNumbers(event);
  }

  onDateChange(event: any, dp: any) {
    let object = new Date(this.cardData[event.target.name]).toISOString().split('T')[0];
    DateHelpers.onDateChange(event, dp, object);
  }
}
